export const SET_NEXT_TIME_THRESHOLD_FOR_UPDATE = "SET_NEXT_TIME_THRESHOLD_FOR_UPDATE";

export const SET_LATEST_SUGGESTED_ARTICLES_BY_USER_ACTIVITIES =
  "SET_LATEST_SUGGESTED_ARTICLES_BY_USER_ACTIVITIES";
